import { useState, useEffect } from 'preact/hooks';
import { appendDashboardFiltersToSearchParams, dashboardFilters, selectedProperty, startDate, endDate } from './state';
import { api } from './api';

interface Conversion {
    id: string;
    name: string;
    event_name: string;
    conversions: number;
    conversionRate: number;
}

const Conversions = () => {
    const [conversionsData, setConversionsData] = useState<Conversion[]>([]);
    const [loading, setLoading] = useState(true);
    const [totalSessions, setTotalSessions] = useState(0);
    
    useEffect(() => {
        if (selectedProperty.value) {
            setLoading(true);
            const params = new URLSearchParams({
                property: selectedProperty.value,
                start: startDate.value,
                end: endDate.value,
            });
            appendDashboardFiltersToSearchParams(params);
            api(`/api/conversions?${params.toString()}`)
            .then(result => {
                setConversionsData(result.data || []);
                setTotalSessions(result.totalSessions || 0);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching conversions data:', error);
                setLoading(false);
            });
        }
    }, [selectedProperty.value, startDate.value, endDate.value, JSON.stringify(dashboardFilters.value)]);

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="card-title">Conversioni</h3>
                {totalSessions > 0 && (
                    <span className="card-subtitle" style={{ fontSize: '13px', color: '#666' }}>
                        {totalSessions} sessioni totali
                    </span>
                )}
            </div>
            {loading ? (
                <div className="loading">
                    <div className="loading-spinner"></div>
                </div>
            ) : conversionsData.length === 0 ? (
                <div className="empty-state">
                    <p>Nessuna conversione configurata</p>
                    <p className="empty-state-hint">Configura le conversioni nella pagina Impostazioni</p>
                </div>
            ) : (
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>Conversione</th>
                            <th className="table-cell-number">Conversioni</th>
                            <th className="table-cell-percentage">Tasso</th>
                        </tr>
                    </thead>
                    <tbody>
                        {conversionsData.map((conversion) => {
                            const style = { '--progress-width': `${conversion.conversionRate}%` } as any;
                            return (
                                <tr key={conversion.id} style={style}>
                                    <td className="table-cell-primary">
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                            <span>{conversion.name}</span>
                                            <span style={{ 
                                                fontSize: '11px', 
                                                color: '#999',
                                                textTransform: 'lowercase'
                                            }}>
                                                {conversion.event_name}
                                            </span>
                                        </div>
                                    </td>
                                    <td className="table-cell-number">
                                        {conversion.conversions}
                                    </td>
                                    <td className="table-cell-percentage">
                                        <strong>{conversion.conversionRate}%</strong>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default Conversions;
